module.exports = __webpack_public_path__ + "img/remove.4e74d401.svg";